import React from "react";
import { blockList } from "../../../../constans/controlToolbar";
import { objToolbar } from "../../../../constans/controlToolbar";
import styles from '../EditorToolbar.module.scss'
import { Tooltip } from "antd";
import ControlBtn from "../../ControlBtn/ControlBtn"

const BlockListButton = ({ onClick, blockType }) => {
  return (
    <div className={styles.container}>
          {objToolbar[blockList]?.map((type) => (
            <Tooltip key={type.inlineStyle} title={type.tooltipTitle}>
              <ControlBtn
                content={type.content}
                active={type.inlineStyle === blockType}
                inlineStyle={type.inlineStyle}
                onClick={onClick}
              />
            </Tooltip>
          ))}
        </div>
  )
}

export default BlockListButton;